app
    .controller('SendOfferCtrl', function ($http, $scope) {
        $scope.currency = 'USD';
        this.cancel = () => {
            this.dismiss();
        };

        this.confirm = () => {
            this.close({$value: {client: this.resolve.client, price: $scope.price, currency: $scope.currency, description: $scope.description}});
        };

        this.$onInit = () => {
        };
    })
    .component('sendOffer', {
        template: `
        <div class="px-4 py-2" style="width: 100%; min-width: 32vw;">
            <div class="header p-1 mb-2 text-center font-go-bold" style="border-bottom: 1px solid #1D1D1B;font-size: 20px;">
                {{ 'modal.sendOffer.title' | translate }}
            </div>
            <div class="body" style="max-height: 400px;">
                <div class="row justify-content-center pb-2 mx-0" style="border-bottom: 1px solid #1D1D1B;">
                    <div class="col-3 text-right">
                        <img style="width:46px;" 
                            ng-src="{{ $ctrl.resolve.client.picture? $ctrl.resolve.client.picture : '/upload/' + $ctrl.resolve.client.defaultPicture }}"/>
                    </div>
                    <div class="col-6 text-left" style="font-size: 20px;vertical-align: middle;line-height: 42px;font-weight: bold;">
                        {{ $ctrl.resolve.client.displayName }}
                    </div>
                </div>
                <div class="text-center mb-2 mt-2 font-go-bold" style="font-size: 20px;"> 
                    <span>{{ 'modal.sendOffer.sendAOffer' | translate }}</span>
                </div>
                <div class="form-group row">
                    <div class="col-8 text-right">
                        <input type="number" ng-model="price" min="0" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57" 
                        placeholder="0,00" class="form-control sg-height-input" style="padding-right:24px;font-size: 20px;text-align:right">
                        <div class="sg-money-input-unit-placeholder">$</div>
                    </div>
                    <div class="col-4">
                        <select class="form-control custom-select" ng-model="currency">
                            <option value="USD" selected> USD </option>
                            <option value="CAD"> CAD </option>
                        </select>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-12">
                        <textarea ng-model="description" rows="6" class="form-control" placeholder="Add a description or detail of you proposition"></textarea>
                    </div>
                </div>
            </div>
            <div class="footer text-center mb-2">
                <button class="btn btn-green font-go-bold btn-200 mb-2" ng-click="$ctrl.confirm()" ng-disabled="!price">
                    {{ 'modal.sendOffer.sendBtn' | translate }}
                </button>
                <br>
                <a class="text-dark text-bold text-underline" href="javascript:void(0);" ng-click="$ctrl.cancel()">{{ 'modal.sendOffer.cancel' | translate }}</a>
            </div>
        </div>
        `,
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        },
        controller: 'SendOfferCtrl'
    });
